﻿window.mAddBtHistoConsultRappel = function (bddRef, optionPopup, idTable, id, funcOk) {
    if (typeof optionPopup.buttons == "undefined") optionPopup.buttons = []
    var pathNomFichier = null
    if (idTable == 0) {
        pathNomFichier = id
        id = null
    }
    if (id == null) { funcOk(optionPopup) }
    else {
        var table = bddRef.table.mGetItem(idTable)
        switch (table.nom) {
            case "structures": case "contact": case "structures_contact":
            case "compte_client": case "compte_client_utilisateur":
            case "com_email_envoi": case "com_email_recu": case "com_rdv":
            case "com_note": case "com_courrier": case "com_sms_envoi":
            case "pipeline": case "projet":
            case "fichier":
            case "doc_cpt":
            case "tournee": case "dates":
            case "hebergement": case "reservation":
            case "sondage":
                bddRef.mAjaxCall({ command: "getupdatehistoconsult", id_table: idTable, id: id, path_nom_fichier: pathNomFichier }, function (data) {
                    if (pathNomFichier == null) {
                        var histoConsult = data.histo_consult[0]
                        optionPopup.buttons.push({
                            name: "favori",
                            icon: "" + ((histoConsult.is_favori == "1") ? "fa-solid" : "fa-regular") + " fa-bookmark",
                            txtTooltip: ((histoConsult.is_favori == "1") ? "Supprimer des favoris" : "Ajouter aux favoris"),
                            onClick: function (e) {
                                histoConsult.is_favori = ((histoConsult.is_favori == "1") ? "0" : "1")
                                bddRef.mAjaxCall({
                                    command: "updatefavorihistoconsult",
                                    id_table: idTable,
                                    id: id,
                                    path_nom_fichier: pathNomFichier,
                                    is_favori: histoConsult.is_favori
                                }, function (data) {
                                    $(window).trigger("updatefavori")
                                })
                                e.component.option("icon", "" + ((histoConsult.is_favori == "1") ? "fa-solid" : "fa-regular") + " fa-bookmark dx-theme-accent-as-text-color")
                                var dxBt = e.component.element().closest(".dx-ctrlbutton").getInstance()
                                dxBt.element().attr("title", ((histoConsult.is_favori == "1") ? "Supprimer des favoris" : "Ajouter aux favoris"))
                                if (histoConsult.is_favori == "1") { mNotify("L'élément a été ajouté à vos favoris", "success", 1000) }
                                else { mNotify("L'élément a été retiré de vos favoris", "success", 1000) }
                                dxBt.hideTooltip()
                            }
                        })

                        if (bddRef.objCptCli.objetMetier.hasAgenda()) {
                            var timeOutLoad = null
                            optionPopup.buttons.push({
                                name: "rappel",
                                icon: "fa-bell fa-regular",
                                txtTooltip: "Rappel",
                                disabled: true,
                                onClick: function (e) {
                                    var dxBtRappel = e.element.closest(".dx-ctrlbutton").getInstance()
                                    if (typeof dxBtRappel.lstRappelActif == 'undefined') return
                                    if (dxBtRappel.lstRappelActif.length == 0) {
                                        mCreateNewRappel()
                                    } else {
                                        console.log("ttrappel")
                                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                            target: e.component.element(),
                                            showCloseButton: false,
                                            position: "bottom",
                                            width: 300,
                                            contentTemplate: function (contentElement) {
                                                contentElement.css("text-align", "left")
                                                contentElement.css("padding", "15px")
                                                var dxBtNew = $("<div style='padding-bottom:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Nouveau rappel",
                                                    width: "100%",
                                                    onClick: function (e) {
                                                        mCreateNewRappel()
                                                        tt.hide();
                                                    }
                                                }).dxCtrlButton("instance");
                                                var dxScroll = $("<div style='height:calc(100% - " + (dxBtNew.element().innerHeight()) + "px);'/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")

                                                var lstIdTableId = []
                                                var idTableRappel = bddRef.table.mGetItemFromNom("rappel").id_table
                                                dxBtRappel.lstRappelActif.forEach(function (rappel) {
                                                    lstIdTableId.push({ id_table: idTableRappel, id: rappel.id_rappel })
                                                })
                                                bddRef.mAjaxCall({ command: "getlstdatavirtualgrid", data: lstIdTableId }, function (data) {
                                                    if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
                                                    data.lstdatatemplate.forEach(function (dataTemplate) {
                                                        var obj = bddRef.getObjet("rappel", dataTemplate.id_key)
                                                        var $Div = $("<div class='state-hover' style='margin:10px 0px;padding:10px;border:" + theme.border + ";background-color:" + theme.grilleBackgroundColorRappel + ";color:black;height:66px;'/>").appendTo(dxScroll.content())
                                                        obj.itemTemplateGrille($Div, dataTemplate, null, { showDate: true })
                                                        $Div.on("click", function () {
                                                            obj.mShowPopup({
                                                                target: dxBtRappel.element()
                                                            })
                                                            tt.hide();
                                                        })
                                                    })
                                                })
                                                resizeObserver.mAdd(contentElement, function () { tt.component().repaint() })
                                            },
                                        }).dxCtrlTooltip("instance");
                                        tt.show();
                                    }
                                    dxBtRappel.hideTooltip()

                                    function mCreateNewRappel() {
                                        var idTable = dxBtRappel.element().attr("idtable")
                                        var id = dxBtRappel.element().attr("id")
                                        console.log("rappel Create : " + idTable + ":" + id + ":" + bddRef.table.mGetItem(idTable).nom)
                                        if (idTable == bddRef.getObjet("structures").mGetTable().id_table ||
                                            idTable == bddRef.getObjet("structures_contact").mGetTable().id_table ||
                                            idTable == bddRef.getObjet("contact").mGetTable().id_table) {
                                            bddRef.getObjet("rappel").objetMetier.mCreateNewRappel(new Date(),
                                                (new Date()).addMinutes(60),
                                                null, null,
                                                [{ id_table: idTable, id: id }],
                                                dxBtRappel.element(),
                                                function () {
                                                    mRempliBtRappel(dxBtRappel)
                                                })
                                        } else {
                                            bddRef.getObjet("rappel").objetMetier.mCreateNewRappel(new Date(),
                                                (new Date()).addMinutes(60),
                                                idTable, id,
                                                null,
                                                dxBtRappel.element(),
                                                function () {
                                                    mRempliBtRappel(dxBtRappel)
                                                })
                                        }
                                    }
                                },
                                onContentReady: function (e) {
                                    window.clearTimeout(timeOutLoad)
                                    timeOutLoad = window.setTimeout(function () {
                                        var dxBtRappel = e.element.closest(".dx-ctrlbutton").getInstance()
                                        dxBtRappel.element().attr("idtable", idTable)
                                        dxBtRappel.element().attr("id", id)
                                        mRempliBtRappel(dxBtRappel)
                                        bddRef.mAddFunctionOnModifiedItemData(["rappel", "rappel_utilisateur"], e.element,
                                            function (action, itemData) {
                                                mRempliBtRappel(dxBtRappel)
                                            })
                                    }, 100)
                                }
                            })
                        }
                    }
                    funcOk(optionPopup)
                })
                break;
            default:
                funcOk(optionPopup)
                break;
        }
        $(window).trigger("openpopupconsult")
    }

    function mRempliBtRappel(dxBt) {

        dxBt.lstRappelActif = [];
        var idTable = dxBt.element().attr("idtable")
        var id = dxBt.element().attr("id")
        console.log("rappel Rempli : " + idTable + ":" + id + ":" + bddRef.table.mGetItem(idTable).nom)
        //if (lstRappelActif.length > 0) {
        if (idTable == bddRef.getObjet("structures").mGetTable().id_table ||
            idTable == bddRef.getObjet("structures_contact").mGetTable().id_table ||
            idTable == bddRef.getObjet("contact").mGetTable().id_table) {

            var idTableId = idTable + ":" + id
            //var idTabStr = bddRef.table.mGetItemFromNom("structures").id_table
            //var idTabStrCon = bddRef.table.mGetItemFromNom("structures_contact").id_table
            //switch (idTable) {
            //    case idTabStr: //"structures":
            //        bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_structures == id }).forEach(function (strcon) {
            //            idTableId += "|" + idTabStrCon + ":" + strcon.id_structures_contact
            //        })
            //        break;
            //    case idTabStrCon://"structures_contact":
            //        var idStr = bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_structures_contact == id })[0].id_structures
            //        var idTableId = idTabStr + ":" + idStr
            //        bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_structures == idStr }).forEach(function (strcon) {
            //            idTableId += "|" + idTabStrCon + ":" + strcon.id_structures_contact
            //        })
            //        break;
            //    case "contact":
            //}

            ////var lstId = ""
            ////lstRappelActif.forEach(function (rap) { lstId += ((lstId.length > 0) ? "," : "") + rap.id_rappel })

            bddRef.mAjaxCall({ command: "getdatasdestcom", idtableid: idTableId, id_utilisateur: bddRef.utiCourant.id_utilisateur }, function (data) {
                data.lstdestcom = JSON.parse(data.lstdestcom)
                //if (typeof data.lstdestcom == 'undefined') data.lstdestcom = []
                dxBt.lstRappelActif = []
                if (data.lstdestcom.length > 0) {
                    dxBt.component().option("icon", "fa-bell fa-solid fa-shake")
                    dxBt.mRempliCompteur(data.lstdestcom.length)
                    data.lstdestcom.forEach(function (destCom) {
                        var rap = bddRef.mGetArray("rappel").filter(function (rap) { return destCom.rappel[0].id_rappel == rap.id_rappel })[0]
                        if (typeof rap != 'undefined') dxBt.lstRappelActif.push(rap)
                    })
                } else {
                    dxBt.component().option("icon", "fa-bell fa-regular dx-theme-accent-as-text-color")
                    dxBt.mRempliCompteur(0)
                }
                dxBt.option("disabled", false)
            })
        } else {
            dxBt.lstRappelActif = bddRef.getObjet("rappel").objetMetier.mGetLstRappelUtilisateurActif().filter(function (rap) { return rap.id_table == idTable && rap.id == id })
            if (dxBt.lstRappelActif.length > 0) {
                dxBt.component().option("icon", "fa-bell fa-solid dx-theme-accent-as-text-color fa-shake")
                dxBt.mRempliCompteur(dxBt.lstRappelActif.length)
            } else {
                dxBt.component().option("icon", "fa-bell fa-regular dx-theme-accent-as-text-color")
                dxBt.mRempliCompteur(0)
            }
            dxBt.option("disabled", false)
        }
        //} else {
        //    dxBt.component().option("icon", "fa-bell fa-regular dx-theme-accent-as-text-color")
        //    dxBt.mRempliCompteur(0)
        //    dxBt.option("disabled", false)
        //}
    }

}